import NonISCoachView from './NonISCoachView';

export default NonISCoachView;
